{
  "companies": {
    "headTitle": "Компании",
    "title": "Компании",
    "sections": {
      "summary": "Сводка",
      "projects": "Проекты",
      "errors": "Ошибки",
      "accounts": "Счета",
      "entries": "Операции",
      "invoices": "Счета на оплату",
      "requisites": "Реквизиты",
      "terms": "Планы",
      "tariffs": "Тарифы",
      "limits": "Лимиты",
      "members": "Сотрудники",
      "models": "Модели",
      "addMember": "Добавить сотрудника",
      "membersEmpty": "Сотрудников пока нет.",
      "invitationsTitle": "Приглашения",
      "invitationsEmpty": "Активных приглашений нет.",
      "inactive": "неактивен",
      "deactivate": "Деактивировать",
      "activate": "Активировать",
      "catalog": "Все проекты"
    },
    "create": "Создать",
    "searchPlaceholder": "Название или slug…",
    "empty": "Пока нет компаний. Нажмите «Создать».",
    "filterEmpty": "Ничего не найдено.",
    "columns": {
      "name": "Компания",
      "slug": "Slug",
      "owner": "Владелец",
      "members": "Пользователи",
      "projects": "Проекты",
      "balance": "Доступно",
      "enforcement": "Биллинг",
      "models": "Модели",
      "createdAt": "Создана"
    },
    "internalBadge": "Служебная",
    "internalHint": "Служебная компания платформы: биллинг не ведётся.",
    "noOwner": "Нет владельца",
    "enforcementBadge": {
      "off": "Выключен",
      "shadow": "Теневой",
      "enforced": "Включён"
    },
    "filters": {
      "enforcement": "Режим биллинга",
      "enforcementReset": "Сбросить фильтр",
      "modelsRestricted": "Только с ограничением моделей",
      "showArchived": "Показывать архивные"
    },
    "totals": "{{companies}} · {{projects}} · {{members}}",
    "totalsWithInternal": "{{totals}} · служебных {{internal}}",
    "companiesCount_one": "{{formatted}} компания",
    "companiesCount_few": "{{formatted}} компании",
    "companiesCount_many": "{{formatted}} компаний",
    "companiesCount_other": "{{formatted}} компании",
    "projectsCount_one": "{{formatted}} проект",
    "projectsCount_few": "{{formatted}} проекта",
    "projectsCount_many": "{{formatted}} проектов",
    "projectsCount_other": "{{formatted}} проекта",
    "membersCount_one": "{{formatted}} пользователь",
    "membersCount_few": "{{formatted}} пользователя",
    "membersCount_many": "{{formatted}} пользователей",
    "membersCount_other": "{{formatted}} пользователя",
    "modelsAll": "Все",
    "modelsOf": "{{count}} из {{total}}",
    "membersLinkTitle": "Показать пользователей компании",
    "projectsLinkTitle": "Показать проекты компании",
    "modelsKind_image": "Изображения",
    "modelsKind_video": "Видео",
    "modelsKind_audio": "Аудио",
    "modelsKind_text": "Текст",
    "modelsKind_transcription": "Транскрипция",
    "modelsKind_post_production": "Постпродакшн",
    "modelsKind_lipsync": "Lipsync",
    "peek": {
      "close": "Закрыть",
      "moreActions": "Действия с компанией",
      "open": "Открыть",
      "openHint": "Открыть страницу компании",
      "rename": "Переименовать",
      "copyLink": "Скопировать ссылку на карточку",
      "linkCopied": "Ссылка скопирована",
      "copyFailed": "Не удалось скопировать ссылку",
      "createdInline": "создана {{date}}",
      "archivedNotice": "В архиве с {{date}}",
      "archivedBy": "Убрал в архив: {{name}}",
      "archive": "Архивировать компанию",
      "unarchive": "Вернуть из архива",
      "billingSection": "Биллинг",
      "billingDashboardLink": "Дашборд",
      "billingJournalLink": "Журнал",
      "billingPriceListLink": "Прайс-лист компании",
      "tileAvailable": "Доступно",
      "tileHeld": "заморожено {{amount}}",
      "tileSpend": "Расход · 30 дн",
      "tileGenerations": "Генераций · 30 дн",
      "tileAverage": "≈ {{amount}} за генерацию",
      "rowMode": "Режим",
      "modeSince": "с {{date}}",
      "rowPlan": "План",
      "planNone": "не назначен",
      "planOpen": "Открыть план",
      "planCancel": "Отменить план",
      "planCancelConfirm": "Отменить план {{code}} для этой компании? Скидка перестанет действовать.",
      "rowTariffs": "Тарифы",
      "overridesCount_one": "{{count}} переопределение",
      "overridesCount_few": "{{count}} переопределения",
      "overridesCount_many": "{{count}} переопределений",
      "overridesCount_other": "{{count}} переопределения",
      "overridesRest": "остальное по GPL",
      "overridesNone": "по платформенному GPL",
      "rowAccounts": "Счета",
      "accountsCount_one": "{{count}} счёт",
      "accountsCount_few": "{{count}} счёта",
      "accountsCount_many": "{{count}} счетов",
      "accountsCount_other": "{{count}} счёта",
      "accountsNone": "счетов нет",
      "accountsColumn": "Счёт",
      "accountsTotal": "Итого",
      "accessSection": "Доступ",
      "rowModels": "Модели",
      "agentModel": "Модель агента",
      "agentModelInherit": "Как на платформе ({{name}})",
      "modelsAll": "Все модели",
      "modelsAllHint": "Ограничений нет: доступно всё, что есть на платформе.",
      "modelsRestricted": "Только выбранные",
      "modelsRestrictedHint": "Доступны только отмеченные модели; остальные видны в списках, но выбрать их нельзя.",
      "modelsTotal": "всего {{total}}",
      "modelsPick": "Выбрать модели…",
      "teamSection": "Команда",
      "owners": "Владельцы",
      "assignOwner": "Назначить владельца",
      "membersWord_one": "пользователь",
      "membersWord_few": "пользователя",
      "membersWord_many": "пользователей",
      "membersWord_other": "пользователя",
      "projectsWord_one": "проект",
      "projectsWord_few": "проекта",
      "projectsWord_many": "проектов",
      "projectsWord_other": "проекта"
    },
    "page": {
      "headTitle": "{{name}} · компания",
      "copyLink": "Скопировать ссылку на страницу",
      "linkCopied": "Ссылка скопирована",
      "planLinkTitle": "Планы и назначения",
      "rowOffer": "Оферта",
      "offerLinkTitle": "Открыть текст оферты",
      "offerAccepted": "принята {{date}} · версия {{version}}",
      "offerMissing": "акцепт не зафиксирован",
      "offerNoOwner": "нет владельца — акцепт не за кем закрепить",
      "moneySection": "Финансы",
      "activitySection": "Активность за год",
      "tileSpend": "Расход за период",
      "tileGenerations": "Генераций за период",
      "running": "{{count}} в работе",
      "accountArchived": "в архиве",
      "accountsEmpty": "Счетов нет. Без основного счёта режимы «{{shadow}}» и «{{enforced}}» недоступны.",
      "tileMembers": "Сотрудники",
      "tileProjects": "Проекты",
      "projectsArchived": "{{count}} в архиве",
      "tileGenerationsTotal": "Генерации",
      "generationsAllTime": "за всё время",
      "tileModels": "Модели",
      "modelsAllSub": "без ограничений",
      "modelsRestrictedSub": "только выбранные",
      "tileOwners": "Владельцы",
      "ownersMore": "{{name}} +{{count}}",
      "membersDeactivated": "деактивированы: {{count}}",
      "membersInvited": "приглашения: {{count}}",
      "membersAllActive": "все активны",
      "accountActions": "Действия со счётом",
      "deposit": "Зачислить",
      "adjust": "Корректировка",
      "setDefault": "Сделать основным",
      "archiveAccount": "Архивировать счёт",
      "transfer": "Перенос между счетами",
      "accountSettings": "Прайс-лист и минус",
      "multiCurrencyEnable": "Включить валютные счета",
      "multiCurrencyDisable": "Выключить валютные счета",
      "multiCurrencyOn": "Валютные счета включены: USD/EUR-счета списывают только проекты, привязанные к ним.",
      "archivedMoneyHint": "Компания в архиве: зачисления, переносы и выставление счетов недоступны до возврата из архива.",
      "invoicesSection": "Счета на оплату",
      "invoicesAll": "Все счета на оплату",
      "issueInvoice": "Выставить счёт",
      "invoicesEmpty": "Счетов на оплату ещё не выставляли.",
      "invoiceTotalsIssued": "выставлено: {{count}} на {{amount}}",
      "invoiceTotalsPaid": "оплачено: {{amount}}",
      "invoiceTotalsOutstanding": "к оплате: {{amount}}",
      "invoiceTotalsExpired": "просрочено: {{count}}",
      "pendingOrder": "ПП на проверке",
      "invoiceActions": "Действия со счётом на оплату",
      "movementsSection": "Движение средств",
      "movementsEmpty": "За период денежных проводок нет.",
      "entryTotalCount": "проводок: {{count}}",
      "showTechnical": "Показать технические",
      "holdsTitle": "Открытые заморозки",
      "holdsEmpty": "Открытых заморозок нет.",
      "holdOverdue": "просрочена",
      "holdColumns": {
        "created": "Создана",
        "amount": "Заморожено",
        "captured": "Списано",
        "remaining": "Осталось",
        "expires": "Истекает"
      },
      "termsSection": "Планы и депозиты",
      "plansAll": "Все планы",
      "plansEmpty": "Планов не назначали.",
      "depositsSummary": "Депозитов: {{count}} · оплачено {{paid}} · зачислено {{credited}} · возвращено {{refunded}}",
      "planDiscount": "скидка {{percent}}%",
      "planTermsColumn": "Условия",
      "requisitesSection": "Реквизиты плательщика",
      "requisitesEmpty": "Компания ещё не заполнила реквизиты.",
      "requisitesDirector": "Руководитель",
      "requisitesContacts": "Контакты",
      "noBankAccounts": "Банковских счетов нет.",
      "onlinePaymentsSection": "Онлайн-оплаты",
      "paymentMethod": "Способ",
      "topProjects": "Проекты по расходу",
      "projectsSpending": "с расходом: {{count}}",
      "projectArchived": "в архиве",
      "boundTitle": "Проекты на отдельных счетах",
      "boundHint": "Остальные проекты списывают с основного счёта.",
      "boundAccountArchived": "счёт в архиве — списания с основного",
      "boundBlocked": "нет средств — генерации остановлены",
      "errorsSection": "Частые ошибки",
      "errorsAll": "Все ошибки",
      "errorsEmpty": "За период генерации без ошибок.",
      "errorNoText": "Без текста ошибки",
      "errorLast": "последняя: {{when}}",
      "sharingSection": "Шаринг проектов",
      "sharingEmpty": "Компания не делится проектами и не получает чужих.",
      "sharingGiven": "Отдано наружу",
      "sharingGivenHint": "Генерации гостей в этих проектах входят в расход компании. Кто выдал доступ, не хранится.",
      "sharingReceived": "Получено по шаре",
      "sharingNone": "Нет.",
      "sharingRevokeGiven": "Отозвать у компании «{{company}}» доступ к проекту «{{project}}»?",
      "sharingRevokeReceived": "Отозвать у этой компании доступ к проекту «{{project}}» компании «{{company}}»?",
      "signals": {
        "no_owner": "Нет владельца",
        "no_default_account": "Нет основного счёта",
        "no_money": "Отрицательный баланс: {{amount}}",
        "no_money_zero": "Нулевой баланс",
        "runway": "Хватит на {{days}} дн.",
        "failures": "Ошибок за сутки: {{count}}",
        "stuck_queue": "Очередь висит: в работе {{count}}, старейшая запущена {{since}}",
        "overdue_holds": "Просроченных заморозок: {{count}} на {{amount}}",
        "unsettled": "Не закрыто расчётов: {{count}}",
        "unrated": "Без тарифа: {{count}}",
        "expired_invoices": "Просрочено счетов: {{count}} на {{amount}}",
        "expired_invitations": "Истекло приглашений: {{count}}",
        "requisites_missing": "Нет реквизитов плательщика",
        "requisites_state": "Статус контрагента: {{state}}",
        "checklist": "Чеклист · {{passed}} из {{total}}",
        "checklistTitle": "Чеклист компании",
        "checklistPassed": "в порядке {{passed}} из {{total}}",
        "groupAttention": "Требует внимания",
        "groupInfo": "К сведению",
        "groupOk": "В порядке",
        "okTitles": {
          "no_owner": "Владелец назначен",
          "no_default_account": "Основной счёт есть",
          "no_money": "Баланс положительный",
          "runway": "Денег хватит примерно на {{days}} дн.",
          "failures": "За сутки генерации без ошибок",
          "stuck_queue": "Очередь не висит",
          "overdue_holds": "Просроченных заморозок нет",
          "unsettled": "Все расчёты закрыты",
          "unrated": "У всех генераций есть тариф",
          "expired_invoices": "Просроченных счетов на оплату нет",
          "expired_invitations": "Истёкших приглашений нет",
          "requisites": "Реквизиты плательщика в порядке"
        },
        "hints": {
          "no_owner": "Без владельца некому управлять командой, биллингом и оплатой, и акцепт оферты не за кем закрепить.",
          "no_default_account": "С основного счёта списываются генерации проектов без своего бюджета. Без него недоступны режимы «{{shadow}}» и «{{enforced}}». Обычно он создаётся сам — при первой генерации, оплате или промокоде.",
          "no_money": "Доступно по активным счетам. В режиме «{{enforced}}» при нуле генерации блокируются, в режиме «{{shadow}}» — продолжаются в минус.",
          "runway": "Прогноз по среднему дневному расходу с первой траты, но не дольше года. Предупреждает, когда денег остаётся на неделю и меньше.",
          "failures": "Упавшие генерации всех видов работ за последние 24 часа — в мониторинге они откроются вместе с текстами ошибок.",
          "stuck_queue": "Генерации в очереди или в работе дольше двух часов: скорее всего, провайдер не ответил или воркер упал.",
          "overdue_holds": "Заморозка резервирует деньги под генерацию и закрывается списанием или возвратом. Просроченная держит деньги клиента дольше срока.",
          "unsettled": "Успешные платные генерации после включения биллинга, по которым не прошло списание со счёта: баланс компании завышен.",
          "unrated": "Успешные генерации без подходящей ставки — они прошли бесплатно. Модели нужна ставка в прайсе.",
          "expired_invoices": "Выставленные счета на оплату, срок которых прошёл, а оплата пришла не целиком.",
          "expired_invitations": "Приглашения, которые не приняли вовремя. Отправить заново или отозвать их может владелец в разделе «Сотрудники» компании.",
          "requisites": "Для счёта на оплату нужны профиль плательщика и активный банковский счёт. Статус по ЕГРЮЛ, отличный от «действующая», — повод проверить компанию до выставления счёта."
        },
        "actions": {
          "no_owner": "Назначить владельца",
          "no_default_account": "К счетам компании",
          "no_money": "К счетам компании",
          "runway": "К счетам компании",
          "failures": "Открыть ошибки в мониторинге",
          "stuck_queue": "Открыть активные в мониторинге",
          "overdue_holds": "К заморозкам",
          "unsettled": "Открыть в журнале расходов",
          "unrated": "Открыть в журнале расходов",
          "expired_invoices": "К счетам на оплату",
          "expired_invitations": "К плитке «Сотрудники»",
          "requisites": "К реквизитам"
        },
        "actionCreateAccount": "Создать счёт"
      }
    },
    "createDialog": {
      "title": "Новая компания",
      "submit": "Создать",
      "cancel": "Отмена",
      "name": "Название",
      "namePlaceholder": "Acme Studio",
      "owner": "Владелец",
      "ownerHint": "Необязательно — владельца можно назначить позже."
    },
    "renameDialog": {
      "title": "Переименовать компанию",
      "submit": "Сохранить",
      "cancel": "Отмена",
      "name": "Название"
    },
    "ownerDialog": {
      "title": "Назначить владельца",
      "submit": "Назначить",
      "cancel": "Отмена",
      "owner": "Владелец",
      "hint": "Пользователь станет владельцем компании и получит полные права в ней."
    },
    "modelsDialog": {
      "title": "Доступные модели",
      "search": "Поиск по названию или ключу…",
      "all": "Все модели",
      "restricted": "Только выбранные",
      "hint": "Без ограничений компании доступны все модели. При ограничении остальные остаются в списках, но выбрать их нельзя.",
      "selected": "Выбрано {{count}} из {{total}}",
      "selectAll": "Выбрать всё",
      "clearAll": "Снять всё",
      "save": "Сохранить",
      "cancel": "Отмена",
      "emptyCatalog": "Каталог моделей пуст.",
      "nothingFound": "Ничего не найдено.",
      "groupCount": "{{selected}} / {{total}}",
      "expandFamily": "Показать версии",
      "collapseFamily": "Скрыть версии"
    },
    "archivedBadge": "Архив",
    "archiveDialog": {
      "title": "Архивировать компанию?",
      "body": "«{{name}}» пропадёт из списков и переключателя компаний, войти в неё не сможет никто, кроме суперадмина. Генерации и любые операции со счетами будут запрещены, проекты исчезнут из каталогов.",
      "reversible": "Компанию можно вернуть из архива в любой момент — данные, деньги и приглашения сохранятся.",
      "money": "На счетах {{balance}}, заморожено {{held}}.",
      "running": "Сейчас выполняется генераций: {{count}}. Они завершатся, новые запускаться не будут.",
      "confirm": "Архивировать",
      "cancel": "Отмена"
    }
  },
  "users": {
    "headTitle": "Пользователи",
    "title": "Пользователи",
    "inviteButton": "Пригласить",
    "searchPlaceholder": "Имя или email…",
    "searching": "Ищем на сервере…",
    "filterByCompany": "Фильтр по компаниям",
    "companyFilterSearch": "Поиск компании…",
    "clearCompanyFilter": "Сбросить",
    "selectedCompaniesGroup": "Выбранные",
    "allCompaniesGroup": "Все компании · {{count}}",
    "removeCompanyChip": "Убрать «{{company}}» из фильтра",
    "onlySuperAdmins": "Только суперадмины",
    "columns": {
      "name": "Имя",
      "email": "Email",
      "companies": "Компании",
      "lastSeen": "Последний вход",
      "active": "Активный"
    },
    "superAdminBadge": "Суперадмин",
    "moreCompanies": "+{{count}}",
    "totals": "{{users}} · {{companies}} · {{superAdmins}}",
    "usersCount_one": "{{formatted}} пользователь",
    "usersCount_few": "{{formatted}} пользователя",
    "usersCount_many": "{{formatted}} пользователей",
    "usersCount_other": "{{formatted}} пользователя",
    "companiesCount_one": "{{formatted}} компания",
    "companiesCount_few": "{{formatted}} компании",
    "companiesCount_many": "{{formatted}} компаний",
    "companiesCount_other": "{{formatted}} компании",
    "superAdminsCount_one": "{{formatted}} суперадмин",
    "superAdminsCount_few": "{{formatted}} суперадмина",
    "superAdminsCount_many": "{{formatted}} суперадминов",
    "superAdminsCount_other": "{{formatted}} суперадмина",
    "found": "Найдено {{found}} из {{total}}",
    "foundInCompany": "{{found}} · компания «{{company}}»",
    "foundInCompanies": "{{found}} · {{companies}}",
    "range": "{{from}}–{{to}} из {{total}}",
    "prevPage": "Предыдущая страница",
    "nextPage": "Следующая страница",
    "empty": "Пока нет пользователей.",
    "filterEmpty": "Ничего не найдено.",
    "open": "Открыть",
    "openHint": "Открыть страницу пользователя",
    "editName": "Изменить имя",
    "copyLink": "Скопировать ссылку на карточку",
    "linkCopied": "Ссылка скопирована",
    "copyFailed": "Не удалось скопировать",
    "meta": "На платформе с {{created}} · последний вход {{lastSeen}}",
    "metaNeverSeen": "На платформе с {{created}} · ещё не входил(а)",
    "emailConfirmed": "email подтверждён",
    "emailNotConfirmed": "email не подтверждён",
    "membershipsSection": "Компании и роли · {{count}}",
    "noMemberships": "Не состоит ни в одной компании.",
    "allProjects": "Все проекты",
    "projectsPrefix": "Проекты:",
    "noProjects": "Нет проектов",
    "deactivatedInCompany": "Деактивирован в компании",
    "roleAria": "Роль в «{{company}}»",
    "lockLastOwner": "Единственный владелец — сначала назначьте другого",
    "lockSelf": "Свою роль изменить нельзя",
    "lockDeactivated": "Сотрудник деактивирован в компании",
    "remove": "Убрать",
    "addToCompany": "Добавить в компанию…",
    "companySearch": "Поиск компании…",
    "companySearchEmpty": "Ничего не найдено",
    "addRoleAria": "Роль в компании",
    "add": "Добавить",
    "confirmPromoteTitle": "Сделать пользователя {{name}} владельцем «{{company}}»?",
    "confirmPromoteMessage": "Владелец видит все проекты, сотрудников и биллинг компании.",
    "confirmPromote": "Сделать владельцем",
    "confirmDemoteTitle": "Снять роль владельца с пользователя {{name}} в «{{company}}»?",
    "confirmDemoteMessage": "Пользователь станет сотрудником и останется только в проектах, где у него есть роль.",
    "confirmDemote": "Снять роль владельца",
    "confirmRemoveTitle": "Удалить пользователя {{name}} из «{{company}}»?",
    "confirmRemoveAssignments": "Назначения на проекты ({{count}}) будут сняты.",
    "confirmRemoveMessage": "История работы останется, пригласить снова можно в любой момент.",
    "confirmRemove": "Удалить из компании",
    "removeMembershipTitle": "Удалить из компании",
    "confirmRemoveMembership": "Удалить {{email}} из компании «{{company}}»?",
    "superAdminSection": "Суперадмин",
    "superAdmin": "Суперадмин платформы",
    "superAdminHint": "Все компании, биллинг и настройки платформы. Включение и снятие подтверждаются вашим паролем.",
    "cannotRevokeSelf": "Нельзя снять права с самого себя — попросите другого суперадмина.",
    "confirmGrantTitle": "Выдать права суперадмина пользователю {{name}}?",
    "confirmGrantMessage_one": "Суперадмин видит все {{formatted}} компанию, их биллинг и настройки платформы и может открыть любую компанию от лица владельца. Для подтверждения введите свой пароль.",
    "confirmGrantMessage_few": "Суперадмин видит все {{formatted}} компании, их биллинг и настройки платформы и может открыть любую компанию от лица владельца. Для подтверждения введите свой пароль.",
    "confirmGrantMessage_many": "Суперадмин видит все {{formatted}} компаний, их биллинг и настройки платформы и может открыть любую компанию от лица владельца. Для подтверждения введите свой пароль.",
    "confirmGrantMessage_other": "Суперадмин видит все {{formatted}} компании, их биллинг и настройки платформы и может открыть любую компанию от лица владельца. Для подтверждения введите свой пароль.",
    "confirmRevokeTitle": "Снять права суперадмина с пользователя {{name}}?",
    "confirmRevokeMessage": "Пользователь потеряет доступ к разделам платформы и к компаниям, где не состоит. Для подтверждения введите свой пароль.",
    "grant": "Выдать права",
    "revoke": "Снять права",
    "confirmPasswordLabel": "Ваш пароль",
    "passwordSection": "Пароль",
    "passwordHint": "Отправим пользователю письмо со ссылкой для смены пароля. Текущий пароль работает, пока он не задаст новый; после смены все сессии завершатся.",
    "sendResetLink": "Отправить ссылку для сброса",
    "sendResetLinkAgain": "Отправить ещё раз",
    "sendResetLinkSelf": "Свой пароль меняется в профиле",
    "resetLinkSentAt": "Ссылка отправлена {{date}}",
    "confirmSendResetTitle": "Отправить ссылку для сброса пароля?",
    "confirmSendResetMessage": "Письмо со ссылкой уйдёт на {{email}}. Ссылка действует 30 минут. Текущий пароль работает, пока пользователь не задаст новый; после смены все его сессии завершатся.",
    "confirmSendReset": "Отправить ссылку",
    "deactivate": "Деактивировать",
    "activate": "Вернуть",
    "lockOwnerDeactivate": "Владельца нельзя деактивировать — сначала смените роль",
    "lockSelfDeactivate": "Себя деактивировать нельзя",
    "deactivateDialogTitle": "Деактивировать {{name}}",
    "deactivateDialogHint": "Доступ к отмеченным компаниям закроется сразу. Человек останется в их составе — вернуть можно в любой момент.",
    "deactivateSubmit": "Деактивировать ({{count}})",
    "deactivateNone": "Нет компаний, где его можно деактивировать",
    "page": {
      "headTitle": "{{name}} · пользователь",
      "moreActions": "Действия с пользователем",
      "copyLink": "Скопировать ссылку на страницу",
      "signOutEverywhere": "Выйти на всех устройствах",
      "signOutSelf": "Свои сессии завершаются в профиле, в разделе «Безопасность»",
      "confirmSignOutTitle": "Завершить все сессии пользователя {{name}}?",
      "confirmSignOutMessage": "Пользователь выйдет во всех браузерах, сессии Claude Desktop будут отозваны. Ключи MCP продолжат работать — их отзывают отдельно.",
      "grantSuperAdmin": "Выдать права суперадмина",
      "revokeSuperAdmin": "Снять права суперадмина",
      "onPlatformSince": "на платформе с {{date}}",
      "lastSeen": "последний вход {{when}}",
      "neverSeen": "ещё не входил(а)",
      "pendingEmail": "смена email на {{email}} не подтверждена",
      "resetLinkSent": "ссылка для сброса пароля отправлена {{date}}",
      "membershipActions": "Действия в компании",
      "columns": {
        "company": "Компания",
        "role": "Роль",
        "joined": "В компании с",
        "projects": "Проектов",
        "spend": "Расход",
        "key": "Ключ",
        "app": "Приложение",
        "created": "Создан",
        "started": "Начата",
        "lastUsed": "Использован",
        "expires": "Истекает",
        "invitedBy": "Пригласил(а)",
        "sent": "Отправлено",
        "validUntil": "Действует до"
      },
      "projectsEmpty": "Назначений на проекты и генераций в проектах за период нет.",
      "apiTokensTitle": "Ключи MCP",
      "apiTokensEmpty": "Ключей нет.",
      "oauthSessionsTitle": "OAuth-сессии",
      "oauthSessionsEmpty": "Сессий нет.",
      "confirmRevokeTokenTitle": "Отозвать ключ «{{name}}»?",
      "confirmRevokeTokenMessage": "Клиенты с этим ключом перестанут работать от имени {{person}}.",
      "confirmRevokeSessionTitle": "Отозвать сессию «{{name}}»?",
      "confirmRevokeSessionMessage": "Приложению придётся снова войти от имени {{person}}.",
      "invitationsTitle": "Входящие приглашения · {{count}}",
      "invitationExpired": "Истекло"
    }
  },
  "projectCatalog": {
    "headTitle": "Каталог проектов",
    "title": "Каталог проектов",
    "empty": "Проекты не найдены",
    "filters": {
      "searchPlaceholder": "Поиск по названию, slug, компании…",
      "allCompanies": "Все компании",
      "companySearch": "Поиск компании…",
      "companyEmpty": "Ничего не найдено",
      "allTypes": "Все типы",
      "lifecycleAll": "Все",
      "lifecycleActive": "Активные",
      "lifecycleArchived": "В архиве",
      "showArchivedCompanies": "Проекты архивных компаний"
    },
    "columns": {
      "id": "ID",
      "name": "Название",
      "company": "Компания",
      "projectType": "Тип",
      "status": "Статус",
      "workflowStage": "Этап",
      "createdBy": "Создал",
      "createdAt": "Создан",
      "updatedAt": "Обновлён",
      "archivedAt": "Архив"
    },
    "archivedBadge": "Архив",
    "prevPage": "Назад",
    "nextPage": "Дальше",
    "pageOf": "Стр. {{page}} / {{pages}}",
    "range": "{{from}}–{{to}} из {{total}}",
    "perPage": "{{count}} / стр."
  },
  "userPicker": {
    "placeholder": "Имя или email…",
    "searching": "Ищем…",
    "failed": "Не удалось загрузить список",
    "retry": "Повторить",
    "nothingFound": "Никого не нашли",
    "truncated": "Показаны первые {{count}} — уточните запрос",
    "clear": "Очистить",
    "empty": "Не выбран"
  }
}
